/** @jsxImportSource @emotion/react */
import React from 'react'
import { NeedsWorkReason } from 'store/types'
import { needsWorkReasonLabel } from './needsWork'

type Props = {
  count?: number | null
  reasons?: NeedsWorkReason[] | null
}

// A charge somebody is following up on, marked where charges are listed.
export const NeedsWorkFlag: React.FC<Props> = ({ count, reasons }) => {
  if (!count) {
    return null
  }

  const why = (reasons ?? []).map(needsWorkReasonLabel).join(', ')
  const title = `Needs Work${count > 1 ? ` (${count} open items)` : ''}${why ? `: ${why}` : ''}`

  return (
    <span
      title={title}
      aria-label={title}
      data-testid="needs-work-flag"
      css={{ marginLeft: 6, color: '#dc3545', whiteSpace: 'nowrap', fontSize: 12 }}>
      <i className="fas fa-flag" />
      {count > 1 && <span css={{ marginLeft: 2, fontWeight: 600 }}>{count}</span>}
    </span>
  )
}
